import { ACTIONS } from '@wix/component-protocol/schema';
import { CustomManifestAction } from '../types';

/*
  This is a mock of the customActions dictionary
  Dedicated only for the testing purposes.
*/
export const customActionsMock: Record<string, CustomManifestAction> = {
  customAction1: {
    displayName: 'customAction1',
    execution: {
      actionType: ACTIONS.ACTION_TYPE.panel,
      panel: {
        panelType: ACTIONS.PANEL_TYPE.inline,
        inline: {
          contentType: ACTIONS.PANEL_CONTENT_TYPE.url,
          url: 'https://localhost:3300/assets/frame-demo.html',
          displayName: 'custom action 1',
        },
      },
    },
  },

  /*
    Should forward action to self element using `self` path
  */
  customAction2: {
    displayName: 'customAction2',
    execution: {
      actionType: ACTIONS.ACTION_TYPE.forward,
      forward: {
        elementPath: '.self',
        actionName: ACTIONS.ACTION_NAME.custom,
        custom: 'customAction2',
      },
    },
  },

  customAction5: {
    displayName: 'customAction5',
    execution: {
      actionType: ACTIONS.ACTION_TYPE.data,
      data: {
        dataItemKey: 'label',
      },
    },
  },

  customAction6: {
    displayName: 'customAction6',
    execution: {
      actionType: ACTIONS.ACTION_TYPE.data,
      data: {
        dataItemKey: 'link',
      },
    },
  },
};

export const customActionsDemoMock: Record<string, CustomManifestAction> = {
  customDataAction: {
    displayName: 'Data Custom Action',
    execution: {
      actionType: ACTIONS.ACTION_TYPE.data,
      data: {
        dataItemKey: 'label',
      },
    },
  },
  customStyleAction: {
    displayName: 'Style Custom Action',
    execution: {
      actionType: ACTIONS.ACTION_TYPE.style,
      style: {
        styleItemKey: 'background',
      },
    },
  },
  customGroupDataAction: {
    displayName: 'Group Data Custom Action',
    execution: {
      actionType: ACTIONS.ACTION_TYPE.displayGroup,
      displayGroup: {
        displayGroupKey: 'dataGroup',
      },
    },
  },
};
